import { useState } from "react"
import { Anchor, SetAnchor } from "../types/types"

export default function useAnchor(): [anchor: Anchor, setAnchor: SetAnchor] {
    const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null)
    return [anchor, setAnchor]
}
